import * as React from 'react';
import { useAchievementSubscription } from './hooks';

/**
 * Note: audio files are from: https://mixkit.co/free-sound-effects/slot-machine/ License states free to use in
 * comercial projects: https://mixkit.co/license/#sfxFree
 */
export const WsNotificationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	useAchievementSubscription();
	return <>{children}</>;
};
